import React from "react";
import { Copy } from "../../../../components/Copy";
import { CellStatus } from "../../../../components/Table";
import { WithDrawIcon } from "../../../../components/Icons/WithDrawIcon";
import { EqualIcon2 } from "../../../wallet-list/styles";
import styled from "styled-components";
import { SortIcon } from "../../../../components/Icons/SortIcon";
import { formatCurrency, roundNumber } from "../../../../services/app";
import { useApp } from "../../../../contexts";
import { DepositIcon } from "../../../../components/Icons/DepositIcon";
import { TransferIcon } from "../../../../components/Icons/TransferIcon";
import { getCoinCodeImage } from "../../../../utils/helper";

const ItemWraper = styled.div`
  padding: 24px 16px 20px 16px;
  border-radius: 16px;
  background: #ffffff;

  &.v2 {
    padding-bottom: 16px;
  }

  & .address {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
  }
  & .amount {
    font-weight: 600;
    font-size: 16px;
    line-height: 25px;
    text-align: right;
    color: #000000;
  }
  & .time {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    text-align: right;
    color: #818181;
  }
  & .text-coin {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #000000;
  }
  & .text-coin2 {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: #000000;
  }
  & .text-type {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #000000;
  }
  & .btc-value {
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    color: rgba(0, 0, 0, 0.6);
  }
  & .amount2 {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: right;
    color: #000000;
  }
  & .amount3 {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    text-align: right;
    color: #818181;
  }
  & .amount4 {
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    color: #000000;
  }
  & .amount5 {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #818181;
  }
  & .textFrom {
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    color: rgba(0, 0, 0, 0.6);
  }
`;

const IconCop = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_786_33326)">
      <path
        d="M10.1787 0V1.46378H1.46378V11.6426H0V1.46378C0 1.05537 0.14143 0.709548 0.425581 0.425581C0.708994 0.142168 1.05537 0 1.46378 0H10.1787ZM12.3574 2.92755C12.7431 2.92755 13.0776 3.06972 13.3616 3.35314C13.645 3.6371 13.7872 3.97184 13.7872 4.35736V14.536C13.7872 14.9446 13.645 15.2903 13.3616 15.5744C13.0774 15.8578 12.7429 16 12.3574 16H4.35754C3.94895 16 3.60276 15.8578 3.31916 15.5744C3.03501 15.2903 2.89358 14.9446 2.89358 14.536V4.35754C2.89358 3.97184 3.03501 3.63729 3.31916 3.35332C3.60258 3.06991 3.94895 2.92774 4.35754 2.92774H12.3574V2.92755ZM12.3574 14.536V4.35754H4.35754V14.5362H12.3574V14.536Z"
        fill="black"
        fill-opacity="0.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_786_33326">
        <rect width="13.7872" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const TransactionItem2 = ({ item, version, sorted, handleSort }) => {
  const {
    code,
    amount,
    toAmount,
    status,
    time,
    coin,
    coinFrom,
    type,
    btc,
    local,
  } = item;
  const { T, formatLocalCurrency, getCurrency } = useApp();
  const getIconType = (type) => {
    switch (type) {
      case "withdraw":
      case "checkout":
        return <WithDrawIcon />;
      case "deposit":
        return <DepositIcon />;
      case "transfer":
        return <TransferIcon />;
      default:
        return <TransferIcon />;
    }
  };
  return (
    <ItemWraper className={version === 2 && "v2"}>
      {version === 1 ? (
        <>
          <div className="flex justify-between items-center">
            <div className="flex gap-[6px]">
              {getIconType(type)}
              <span className="text-type capitalize"> {T(type)}</span>
            </div>
            <div className="amount" style={{ fontSize: 14 }}>
              {formatCurrency(amount, null, getCurrency())}
            </div>
          </div>
          <div className="mt-1 flex justify-between items-center">
            <span className="time">{time}</span>
            <CellStatus className="v2" text={status}>
              {T(status)}
            </CellStatus>
          </div>
        </>
      ) : (
        <>
          <div className="flex justify-between">
            <div
              className="flex gap-[6px]"
              onClick={(e) => e.stopPropagation()}
            >
              <Copy
                textStyle={{
                  fontWeight: 400,
                  fontSize: 16,
                  lineHeight: "24px",
                }}
                cutText={true}
                splitFont={5}
                numDot={3}
                text={code}
                icon={<IconCop />}
              />
            </div>
            <CellStatus className="v2" text={status}>
              {T(status)}
            </CellStatus>
          </div>
          <div>
            <span className="time">{time}</span>
          </div>
          <div className="mt-[13px] flex gap-5">
            {getCoinCodeImage(coinFrom) && (
              <div className="flex gap-[10px] items-center">
                <span className="textFrom">{T("From1")}</span>
                <span>
                  <div className="flex gap-[8px] items-center">
                    <img
                      alt={" "}
                      style={{ width: 24, height: 24 }}
                      src={`/assets/images/otc/crypto/${getCoinCodeImage(
                        coinFrom
                      )?.toLowerCase()}.svg`}
                    />
                    <div>
                      <div className="text-coin2"> {coinFrom}</div>
                      <div className="amount4">
                        {["ETH", "SZT"].includes(coinFrom) || amount < 1
                          ? formatCurrency(amount, null, getCurrency())
                          : formatCurrency(amount, 2, getCurrency())}
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            )}

            {getCoinCodeImage(coin) && (
              <div className="flex gap-[10px] items-center">
                <span className="textFrom">{T("To1")}</span>

                <span>
                  <div className="flex gap-[8px] items-center">
                    <img
                      alt={" "}
                      style={{ width: 24, height: 24 }}
                      src={`/assets/images/otc/crypto/${getCoinCodeImage(
                        coin
                      )?.toLowerCase()}.svg`}
                    />
                    <div>
                      <div className="text-coin2"> {coin}</div>
                      <div className="amount4">
                        {["ETH", "SZT"].includes(coin) || toAmount < 1
                          ? formatCurrency(toAmount, null, getCurrency())
                          : formatCurrency(toAmount, 2, getCurrency())}
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            )}
          </div>
          <div
            className="w-full h-[1px] mt-[20px]"
            style={{ background: "rgba(0, 0, 0, 0.1)" }}
          ></div>
          <div className="mt-[11px] flex">
            <div className="flex gap-[6px] items-center">
              <span className="btc-value">{T("BTC Value")}</span>
              <span onClick={handleSort} className="cursor-pointer">
                <SortIcon status={sorted} />
              </span>
            </div>
            <span className="amount2 ml-[4px]">{formatCurrency(btc, null, getCurrency())}</span>
            <div className="flex items-center gap-[8px] ml-[8px]">
              <EqualIcon2 />
              <span className="amount5">
                {formatLocalCurrency(local)}
              </span>
            </div>
          </div>
        </>
      )}
    </ItemWraper>
  );
};

export default TransactionItem2;
